export const endpoints = {
    // Auth
    providers: 'oauth2/providers',
    refreshToken: 'oauth2/refresh',
    token: 'oauth2/token',
    logout: 'oauth2/logout',
    changeUser: 'oauth2/change-user',

    // User
    users: 'users',
    user: 'oauth2/user',

    unities: 'unities',
    sites: 'sites',
};
